import NotFound from './NotFound';

export { NotFound };
